import { render, staticRenderFns } from "./DynamicButtonMessageEditor.vue?vue&type=template&id=82371bb2&scoped=true"
import script from "./DynamicButtonMessageEditor.vue?vue&type=script&lang=js"
export * from "./DynamicButtonMessageEditor.vue?vue&type=script&lang=js"
import style0 from "./DynamicButtonMessageEditor.vue?vue&type=style&index=0&id=82371bb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82371bb2",
  null
  
)

export default component.exports